<template>
    <div class="customerDefinedAlarmConfigurationSearch">
        <Row :gutter="4">
            <!-- 选择公司 -->
            <div v-if="company==1">
              <Col span="4">
                  <Select v-model="companyId" filterable :placeholder="$t('ApprovalTask.selectByCompany')" :transfer="true" @on-change="searchCompany">
                      <Option value=" ">{{ $t('ApprovalTask.selectAll') }}</Option>
                      <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                  </Select>
              </Col>
            </div>
            <Col span="4">
                <Select v-model="accountTypeSearchKey" filterable :placeholder="$t('resourceLifecycle.pleaseSelect')"  @on-change="searchAccountType(accountTypeSearchKey)" :transfer="true">
                    <Option value=" ">{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.id" v-for="item in accountTypeList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="4">
              <div style="display: flex">
                <Button type="primary" @click="to" v-hasPermission="['configurationManagement:alertRuleLists']">{{ this.$t('configuration_management.customized_alarm_config.checkTheListOfAlarmRules') }}</Button>
                <Button v-if="company == 1" type="primary" style="margin-left: 5px" @click="showAIDialog">{{ this.$t('configuration_management.customized_alarm_config.setUpAUniversalAIAlarmHandlingProcess') }}</Button>
              </div>
            </Col>
        </Row>
      <Modal
        v-model="openAIDialog"
        width="800"
        :title="$t('configuration_management.customized_alarm_config.setUpAUniversalAIAlarmHandlingProcess')"
        footer-hide
      >
        <div v-for="item in aiList" :key="item.priority">
          <Card style="margin-top: 10px">
            <div style="font-weight: 700;position: absolute;top: 5px;left: 5px">{{ item.priorityShowName }}</div>
            <div style="margin-left: 30px;display: flex;justify-content: space-between">
              <div>
                <Steps :current="3" size="small">
                  <Step v-for="(val, index) in item.sopSteps" :key="val.stepId">
                    <div slot="icon" style="background-color: #2d8cf0;color: #ffffff;width: 18px;height: 18px;border-radius: 50%;font-size: 12px;line-height: 18px;">
                      {{ index + 1 }}
                    </div>
                    <div v-if="index === item.sopSteps.length - 1" slot="title" style="color: #2d8cf0">*邮件模板请进入编辑页面配置</div>
                    <div slot="content" style="width: 100px;">{{ val.stepInfo }}</div>
                  </Step>
                </Steps>
              </div>
              <div>
                <Button type="primary" @click="showSopItem(item)">{{ $t('configuration_management.customized_alarm_config.editAIAlarmProcess') }}</Button>
                <div style="display: flex;margin-top: 40px">
                  <div style="margin-right: 10px;width: 120px;">{{ $t('configuration_management.customized_alarm_config.whetherToEnableEmailNotifications') }}</div>
                  <i-switch v-model="item.enableEmail" @on-change="changeStatus(item)" />
                </div>
              </div>
            </div>
          </Card>
        </div>
      </Modal>
      <Modal
        v-model="showEditAI"
        width="800"
        :title="$t('configuration_management.customized_alarm_config.editGeneralAIAlarmProcess')"
        @on-ok="submitSopItem"
      >
        <div>
          <Card>
            <div style="font-weight: 700;">{{ aiItemData.priorityShowName }}</div>
            <div style="display: flex;margin-top: 10px;">
              <div style="width: 60%;">
                <div>{{ $t('configuration_management.customized_alarm_config.pleaseEnterTheProcessContent') }}</div>
                <Input v-model="processContent" type="textarea" :rows="3" :placeholder="$t('permission_configuration_management.common.pleaseInput')" />
                <Steps :current="sopSteps.length" size="small" style="margin-top: 20px">
                  <Step v-for="(val, index) in sopSteps" :key="val.stepId">
                    <div slot="icon" style="background-color: #2d8cf0;color: #ffffff;width: 18px;height: 18px;border-radius: 50%;font-size: 12px;line-height: 18px;">
                      {{ index + 1 }}
                    </div>
                    <div slot="content" style="width: 100px;">{{ val.stepInfo }}</div>
                  </Step>
                </Steps>
              </div>
              <div style="width: 40%;margin-top: 40px">
                <div style="display: flex;margin-left: 50px">
                  <Button :loading="aiLoading" type="primary" @click="aiIdentification">{{ $t('configuration_management.customized_alarm_config.identification') }}</Button>
                  <div style="margin-left: 40px">
                    <div style="font-weight: 700;">*{{ $t('Bill.ResourceOptimization.prompt') }}</div>
                    <div>{{ aiTips }}</div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <Card style="margin-top: 10px">
            <div>{{ $t('configuration_management.customized_alarm_config.pleaseConfigureTheNotificationTemplate') }}</div>
            <div style="margin-top: 10px">
              <Table border :columns="tableColumns" :data="aiItemData.sopEmailTemplates">
                <template slot-scope="{ row, index }" slot="action">
                  <div style="display: flex;">
                    <Button
                      type="text"
                      size="small"
                      style="color: #2d8cf0"
                      @click="submitItem(row)"
                    >
                      {{ $t("common.ok") }}</Button
                    >
<!--                    <Button-->
<!--                      v-if="index > 1"-->
<!--                      type="text"-->
<!--                      size="small"-->
<!--                      style="color: #ed4014;"-->
<!--                      @click="deleteItem(index)"-->
<!--                    >-->
<!--                      {{ $t("common.del") }}</Button-->
<!--                    >-->
                  </div>
                </template>
              </Table>
<!--              <Button type="primary" shape="circle" icon="md-add" style="margin-top: 10px" @click="addTableItem"></Button>-->
            </div>
          </Card>
        </div>
      </Modal>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import TableCustomerDefinedAlarmConfiguration from '../customer_defined_alarm_configuration/TableCustomerDefinedAlarmConfiguration'
    var tableCustomerDefinedAlarmConfiguration = TableCustomerDefinedAlarmConfiguration;
    export default {
        name: 'CustomerDefinedAlarmConfigurationSearch',
        data () {
            return {
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                accountTypeSearchKey:'-1',
                accountTypeList:[],
                accountTypeNames:'',
              openAIDialog: false,
              aiList: [],
              showEditAI: false,
              processContent: '',
              // 编辑状态记录，格式为 { rowIndex_field: boolean }
              editingState: {},
              // 当前编辑的值，用于临时存储
              editingValue: '',
              tableColumns: [
                {
                  title: this.$t('message.templateName'),
                  key: 'templateName',
                  width: 100,
                  render: (h, params) => {
                    // 获取当前单元格的编辑状态
                    const editingKey = `${params.index}_templateName`;
                    const isEditing = this.editingState[editingKey];
                    if (isEditing) {
                      return h('Input', {
                        props:{
                          type:'text',
                          value: params.row.templateName
                        },
                        on: {
                          input: (event) => {
                            params.row.templateName = event;
                          },
                          'on-blur': () => {
                            this.saveEdit(params.index, 'templateName');
                          }
                        }
                      });
                    } else {
                      return h('div', {
                        // on: {
                        //   dblclick: () => {
                        //     this.startEdit(params.index, 'templateName');
                        //   }
                        // },
                        // style: {
                        //   cursor: 'pointer',
                        //   minHeight: '30px',
                        //   lineHeight: '30px'
                        // }
                      }, params.row.templateName);
                    }
                  }
                },
                {
                  title: this.$t('configuration_management.customized_alarm_config.recipient'),
                  slot: 'recipient',
                  width: 150,
                  render: (h, params) => {
                    // 获取当前单元格的编辑状态
                    const editingKey = `${params.index}_recipient`;
                    const isEditing = this.editingState[editingKey];
                    if (isEditing) {
                      return h('Input', {
                        props:{
                          type:'text',
                          value: params.row.recipient
                        },
                        on: {
                          input: (event) => {
                            params.row.recipient = event;
                          },
                          'on-blur': () => {
                            this.saveEdit(params.index, 'recipient');
                          }
                        }
                      });
                    } else {
                      return h('div', {
                        on: {
                          dblclick: () => {
                            this.startEdit(params.index, 'recipient');
                          }
                        },
                        style: {
                          cursor: 'pointer',
                          minHeight: '30px',
                          lineHeight: '30px'
                        }
                      }, params.row.recipient);
                    }
                  }
                },
                {
                  title: this.$t('alarms.common.emailTemplate'),
                  slot: 'templateContent',
                  render: (h, params) => {
                    // 获取当前单元格的编辑状态
                    const editingKey = `${params.index}_templateContent`;
                    const isEditing = this.editingState[editingKey];
                    if (isEditing) {
                      return h('Input', {
                        props:{
                          type:'textarea',
                          rows: 3,
                          value: params.row.templateContent
                        },
                        on: {
                          input: (event) => {
                            params.row.templateContent = event;
                          },
                          'on-blur': () => {
                            this.saveEdit(params.index, 'templateContent');
                          }
                        }
                      });
                    } else {
                      return h('div', {
                        on: {
                          dblclick: () => {
                            this.startEdit(params.index, 'templateContent');
                          }
                        },
                        style: {
                          cursor: 'pointer',
                          minHeight: '30px',
                          lineHeight: '30px'
                        }
                      }, params.row.templateContent);
                    }
                  }
                },
                {
                  title: this.$t("common.operation"),
                  slot: "action",
                  width: 120
                }
              ],
              aiItemData: {},
              aiTips: '',
              sopSteps: [],
              aiLoading: false
            }
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
            this.getAccountType();
        },
        methods: {
            // 跳转
            to: function() {
               this.$router.push({
                  path: '/configurationManagement/alertRuleLists',
                  query: { companyId: this.companyId }
               });
            },
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
               this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                 .then(res => {
                     this.companyList = res.data;
                 });
            },
            // 按公司搜索
            searchCompany: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('companyId', this.companyId);
                tableCustomerDefinedAlarmConfiguration.methods.showAll();
            },
            //查询账户类型
            getAccountType: function(){
                this.$api.account.queryCloudPlatforms("userName",getCookie(global.cookieName))
                .then(res => {
                    this.accountTypeList = res.data;
                })
            },
            // 按账户类型筛选
            searchAccountType: function(){
                eventBus.$emit('accountTypeNames', this.accountTypeSearchKey);
                tableCustomerDefinedAlarmConfiguration.methods.showAll();
            },
          // 打开通用AI SOP
          showAIDialog() {
            this.openAIDialog = true
            this.$api.customerDefinedAlarmConfiguration.defaultSopList().then(res => {
                this.aiList = res.data.data
            })
          },
          // 打开编辑SOP弹框
          showSopItem(e) {
            this.showEditAI = true
            this.aiItemData = e
            this.processContent = ''
            this.aiTips = ''
            this.sopSteps = []
          },
          changeStatus(e) {
            this.$api.customerDefinedAlarmConfiguration.updateEmailStatus(e.sopId, e.enableEmail).then(res => {
              if (res.data.code === 200) {
                this.$Message.success('修改成功')
              } else {
                this.$Message.error(res.data.message)
              }
            })
          },
          // ai识别
          aiIdentification() {
              this.aiLoading = true
            if (this.processContent) {
              const data = {
                userInput: this.processContent,
                emailTemplateList: this.aiItemData.sopEmailTemplates.map(item => item.templateName)
              }
              this.$api.customerDefinedAlarmConfiguration.sopIdentify(data).then(res => {
                if (res.data.code !== 200) {
                  this.aiTips = res.data.message
                  this.sopSteps = []
                } else {
                  this.aiTips = ''
                  this.sopSteps = res.data.data
                }
              }).finally(() => {
                this.aiLoading = false
              })
            }
          },
          // 新增列表项
          addTableItem() {
              this.aiItemData.sopEmailTemplates.push({
                templateName: '',
                recipient: '',
                templateContent: ''
              })
          },
          deleteItem(i) {
            this.aiItemData.sopEmailTemplates.splice(i, 1)
          },
          // 开始编辑
          startEdit(index, field) {
            const editingKey = `${index}_${field}`;
            this.$set(this.editingState, editingKey, true);
          },
          // 保存编辑
          saveEdit(index, field) {
            const editingKey = `${index}_${field}`;
            // 退出编辑状态
            this.$set(this.editingState, editingKey, false);
          },
          submitItem(e) {
              const data = {
                id: e.id,
                templateName: e.templateName,
                recipient: e.recipient,
                templateContent: e.templateContent
              }
            this.$api.customerDefinedAlarmConfiguration.sopConfirm(data).then(res => {
              this.$Message.success('确认成功')
            })
          },
          submitSopItem() {
              if (this.sopSteps.length <= 0) {
                this.$Message.error('步骤信息不能为空')
                return
              }
            const data = {
              defaultSopPriority: this.aiItemData.priority,
              enableEmail: this.aiItemData.enableEmail,
              sopSteps: this.sopSteps
            }
            this.$api.customerDefinedAlarmConfiguration.defaultSop(data).then(res => {
              if (res.data.code === 200) {
                this.$Message.success('提交成功')
                this.showEditAI = false
                this.$api.customerDefinedAlarmConfiguration.defaultSopList().then(res => {
                  this.aiList = res.data.data
                })
              } else {
                this.$Message.error(res.data.message)
              }
            })
          }
        }
    }
</script>
<style>
    .customerDefinedAlarmConfigurationSearch
    {
        padding: 4px 0px 15px 0px;
    }
    .ivu-steps-item.ivu-steps-status-wait .ivu-steps-head-inner {
      background-color: #2d8cf0;
    }
    .ivu-steps-horizontal .ivu-steps-title:after {
      background: #2d8cf0;
      margin-top: 10px;
      left: -100%
    }
    .ivu-steps.ivu-steps-small .ivu-steps-title {
      color: #2d8cf0;
    }
    .ivu-steps.ivu-steps-small .ivu-steps-content {
      padding-left: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/CustomerDefinedAlarmConfigurationSearch.vue